//CSS
import "../../Components/Page/Page.css";


//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";
// import Table from "../../Components/Tables/Table";

// Media
import map from "../../Images/Discover/colored_map.png";

const GlobalIP: React.FC = () => {
  return (
    <div id="Goals" className="sectionContainer">
      <SecHeader title="Global IP" />
      <SubSection>
        <ImageComp imageSource={map} width={"Max(20rem, 25vw)"} />
        <div className="inv-items">
          <div className="inv-item">
            <h4 className="inv-item-title">IP Actions & Protections with Intellectual Property Insurance Services Corp. (IPISC)</h4>
            <p className="inv-item-body">
              <br/>We are acquiring and protecting IP rights globally to license IP rights in the
            contries making 75% of global engines. <br/><br/>
            Some target IP rights countries analyzed for costs to gain and defend
            IP rights, engine production, and engine sales are vizualized on the left.</p>
          </div>
        </div>
      
      </SubSection>
      {/* <Section isSplit={false}>
        <Table columns={6}/>
      </Section> */}
    </div>
  );
};

export default GlobalIP;
